export enum DeliveryStatus {
  BOUNCE = "BOUNCE",
  DELIVERY = "DELIVERY",
  SENDING = "SENDING",
  FAILED = "FAILED",
}
